module.exports = __webpack_public_path__ + "static/img/img_bg2.20e8f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_bg2.png
// module id = ib7F
// module chunks = 1